module.exports = __webpack_public_path__ + "images/marketing_site/iphone_app/phone_banner.png";